export const checkAndFormat12HourTimings = (inputValue: string, meridiemValue: string = 'am') => {
  const BUSINESS_FORMAT_12HOUR_AM_HOUR = /^(0?9|1[01])$/g;
  const BUSINESS_FORMAT_12HOUR_PM_HOUR = /^(0?[1-4])$/g;
  const BUSINESS_FORMAT_24HOUR_TO_12HOUR_PM_HOUR = /^(1[2-6])$/g;
  const BUSINESS_FORMAT_12HOUR_AM = /^(0?9|1[01]):?([0-5][0-9]?)?\s?([Aa][Mm])?$/g;
  const BUSINESS_FORMAT_12HOUR_PM = /^(0?[1-4]):?([0-5][0-9]?)?\s?([Pp][Mm])?$/g;
  const BUSINESS_FORMAT_12HOUR = /^(12):?([0-5][0-9]?)?\s?([Pp][Mm])?$/g;
  const BUSINESS_FORMAT_24HOUR_TO_12HOUR_PM = /^(1[3-6]):?([0-5][0-9]?)?\s?$/g;
  const NON_BUSINESS_FORMAT_12HOUR = /^(0?[5-8]):?([0-5][0-9]?)?\s?([APap][Mm])?$/g;
  const NON_BUSINESS_FORMAT_24HOUR_TO_12HOUR = /^(1[7-9]|2[0-3]):?([0-5][0-9]?)?\s?$/g;
  const NON_BUSINESS_FORMAT_0HOUR_TO_12HOUR_AM = /^(00?):?([0-5][0-9]?)?\s?([Aa][Mm])?$/g;

  let formattedValue = inputValue;
  formattedValue = checkAndFormatTimingsUsingRegex(BUSINESS_FORMAT_12HOUR_AM_HOUR, inputValue, 'am');
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(BUSINESS_FORMAT_12HOUR_PM_HOUR, inputValue, 'pm');
  }
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(
      BUSINESS_FORMAT_24HOUR_TO_12HOUR_PM_HOUR,
      inputValue,
      'pm',
    );
  }
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(BUSINESS_FORMAT_12HOUR, inputValue, 'pm');
  }
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(BUSINESS_FORMAT_12HOUR_PM, inputValue, 'pm');
  }
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(BUSINESS_FORMAT_12HOUR_AM, inputValue, 'am');
  }
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(
      BUSINESS_FORMAT_24HOUR_TO_12HOUR_PM,
      inputValue,
      'pm',
      '24',
    );
  }
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(NON_BUSINESS_FORMAT_12HOUR, inputValue, meridiemValue);
  }
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(
      NON_BUSINESS_FORMAT_24HOUR_TO_12HOUR,
      inputValue,
      meridiemValue,
      '24',
    );
  }
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormatTimingsUsingRegex(
      NON_BUSINESS_FORMAT_0HOUR_TO_12HOUR_AM,
      inputValue,
      'am',
    );
  }
  return formattedValue;
};
const formattingMintues = (minute: string) => {
  return minute.length === 1 ? minute + '0' : minute;
};

const formatting24HourTo12Hour = (hour: string) => {
  return Number(hour) > 12 ? Number(hour) - 12 : Number(hour);
};

const formattingMeridiem24HourTo12Hour = (hour: string, meridiemValue: string) => {
  return Number(hour) > 12 ? 'pm' : meridiemValue;
};

const formatting0HourTo12Hour = (hour: string) => {
  return Number(hour) === 0 ? 12 : Number(hour);
};

const checkAndFormatTimingsUsingRegex = (
  regex: RegExp,
  inputValue: string,
  meridiemValue: string = 'am',
  timeFormat: '12' | '24' = '12',
) => {
  const matchedValues = inputValue.matchAll(regex).next().value;

  if (matchedValues && matchedValues.length === 4 && timeFormat === '12') {
    if (matchedValues[2] && matchedValues[3]) {
      return `${formatting0HourTo12Hour(matchedValues[1])}:${formattingMintues(matchedValues[2])} ${
        matchedValues[3]
      }`;
    } else if (matchedValues[2]) {
      return `${formatting0HourTo12Hour(matchedValues[1])}:${formattingMintues(
        matchedValues[2],
      )} ${meridiemValue}`;
    }
    return `${formatting0HourTo12Hour(matchedValues[1])}:00 ${meridiemValue}`;
  }
  if (matchedValues && matchedValues.length === 3 && timeFormat === '24') {
    if (matchedValues[2]) {
      return `${formatting24HourTo12Hour(matchedValues[1])}:${formattingMintues(
        matchedValues[2],
      )} ${formattingMeridiem24HourTo12Hour(matchedValues[1], meridiemValue)}`;
    }
    return `${formatting24HourTo12Hour(matchedValues[1])}:00 ${formattingMeridiem24HourTo12Hour(
      matchedValues[1],
      meridiemValue,
    )}`;
  }
  if (matchedValues && matchedValues.length === 2 && timeFormat === '12') {
    if (matchedValues[1] && matchedValues[1].length === 2 && meridiemValue === 'pm') {
      return `${formatting24HourTo12Hour(matchedValues[1])}:00 ${meridiemValue}`;
    }
    return `${formatting0HourTo12Hour(matchedValues[1])}:00 ${meridiemValue}`;
  }
  return inputValue;
};

export const format12HourTimings = (inputValue: string, isPreviousTimeInAm: boolean = true) => {
  let isValid12HourTimeFormat = false;
  const REGEX_CHECK_12_HOUR_FORMAT_WITH_AM_OR_PM = /^(0?[1-9]|1[0-2]):([0-5][0-9]) ([AaPp][Mm])$/;
  isValid12HourTimeFormat = new RegExp(REGEX_CHECK_12_HOUR_FORMAT_WITH_AM_OR_PM).test(inputValue);
  if (!isValid12HourTimeFormat) {
    return checkAndFormat12HourTimings(inputValue, isPreviousTimeInAm ? 'am' : 'pm');
  }
  return inputValue;
};

const checkAndFormat24HourTimings = (regex: RegExp, inputValue: string) => {
  const matchedValues = inputValue.matchAll(regex).next().value;
  if (matchedValues && matchedValues.length >= 2) {
    if (matchedValues[1] && matchedValues[2]) {
      return `${Number(matchedValues[1])}:${formattingMintues(matchedValues[2])}`;
    } else if (matchedValues[1]) {
      return `${Number(matchedValues[1])}:00`;
    }
  }
  return inputValue;
};

export const format24Hours = (inputValue: string) => {
  const FORMAT_24_HOUR_ONLY = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):?\s?$/g;
  const FORMAT_24_HOUR_WITH_MINUTES = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):?([0-5][0-9]?)?\s?$/g;
  let formattedValue = inputValue;
  formattedValue = checkAndFormat24HourTimings(FORMAT_24_HOUR_ONLY, inputValue);
  if (formattedValue === inputValue) {
    formattedValue = checkAndFormat24HourTimings(FORMAT_24_HOUR_WITH_MINUTES, inputValue);
  }
  return formattedValue;
};

export const format24HourTimings = (inputValue: string) => {
  let isValid24HourTimeFormat = false;
  let formatted24HourValue = inputValue;
  const REGEX_CHECK_24_HOUR_FORMAT = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
  isValid24HourTimeFormat = new RegExp(REGEX_CHECK_24_HOUR_FORMAT).test(inputValue);
  if (!isValid24HourTimeFormat) {
    formatted24HourValue = format24Hours(inputValue);
  }
  return formatted24HourValue;
};
